/* YESSKIN · Capa de conversión "cv-*": cuenta regresiva real, dolor interactivo,
   reveal, scroll a la compra, carrusel de opiniones y textos rotativos. */
(function () {
  if (window.__cvLanding) return; window.__cvLanding = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- reveal ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function reveal(root) { $$('[data-cv-reveal]', root).forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-in'); }); }

  /* ---------- cuenta regresiva con fecha real ----------
     data-cv-cd · data-start (ISO, opcional) · data-end (ISO)
     hijos: [data-cv-d|h|m|s], [data-cv-label] (data-before / data-during)
     al terminar agrega .is-over (se ocultan [data-cv-live], aparecen [data-cv-over]) */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function initCd(el) {
    if (el.__cv) return; el.__cv = true;
    var end = Date.parse(el.getAttribute('data-end'));
    var start = Date.parse(el.getAttribute('data-start') || '');
    if (isNaN(end)) { el.classList.add('is-over'); return; }
    var dE = $('[data-cv-d]', el), hE = $('[data-cv-h]', el), mE = $('[data-cv-m]', el), sE = $('[data-cv-s]', el);
    var dBox = dE && dE.closest('[data-cv-dbox]');
    var labels = $$('[data-cv-label]', el);
    var timer;
    function set(node, v) { if (node && node.textContent !== v) node.textContent = v; }
    function tick() {
      var now = Date.now();
      var left = end - now;
      if (left <= 0) { el.classList.add('is-over'); el.classList.remove('is-before', 'is-during'); clearInterval(timer); document.dispatchEvent(new CustomEvent('cv:cd-over')); return; }
      var before = !isNaN(start) && now < start;
      el.classList.toggle('is-before', before); el.classList.toggle('is-during', !before);
      labels.forEach(function (l) { var t = before ? l.getAttribute('data-before') : l.getAttribute('data-during'); if (t) set(l, t); });
      var t = Math.floor(left / 1000), d = Math.floor(t / 86400);
      set(dE, '' + d); if (dBox) dBox.hidden = d <= 0;
      set(hE, pad(Math.floor((t % 86400) / 3600))); set(mE, pad(Math.floor((t % 3600) / 60))); set(sE, pad(t % 60));
    }
    tick(); timer = setInterval(tick, 1000);
  }

  /* ---------- textos rotativos (barra cuando no hay campaña) ---------- */
  function initRotator(el) {
    if (el.__cv) return; el.__cv = true;
    var items = $$('span', el); if (!items.length) return;
    var i = 0; items[0].classList.add('is-on');
    if (items.length < 2 || reduce) return;
    setInterval(function () { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 3200);
  }

  /* ---------- ¿Te pasa esto? ---------- */
  function initPain(root) {
    if (root.__cv) return; root.__cv = true;
    var its = $$('[data-cv-pain-it]', root);
    var cnt = $('[data-cv-pain-n]', root), title = $('[data-cv-pain-title]', root), hint = $('[data-cv-pain-hint]', root);
    var total = its.length;
    function update() {
      var n = its.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; }).length;
      if (cnt) { cnt.textContent = n; cnt.classList.remove('is-bump'); void cnt.offsetWidth; cnt.classList.add('is-bump'); }
      if (title) {
        var tpl = n === 0 ? title.getAttribute('data-zero') : (n === 1 ? title.getAttribute('data-one') : title.getAttribute('data-many'));
        if (tpl) title.textContent = tpl.replace('[n]', n).replace('[t]', total);
      }
      if (hint && n > 0) hint.hidden = true;
      root.classList.toggle('has-picks', n > 0);
    }
    its.forEach(function (b) {
      b.addEventListener('click', function () {
        b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        if (navigator.vibrate && !reduce) { try { navigator.vibrate(12); } catch (e) {} }
        update();
      });
    });
  }

  /* ---------- carrusel simple con puntos ---------- */
  function initRail(root) {
    if (root.__cv) return; root.__cv = true;
    var track = $('[data-cv-rail-track]', root), dots = $('[data-cv-rail-dots]', root);
    if (!track || !dots) return;
    var cards = $$('[data-cv-rail-card]', track);
    dots.innerHTML = cards.map(function () { return '<i></i>'; }).join('');
    var ds = $$('i', dots);
    function mark() {
      var c = track.scrollLeft + track.clientWidth / 2, best = 0, bd = 1e9;
      cards.forEach(function (k, i) { var m = k.offsetLeft + k.offsetWidth / 2; var dd = Math.abs(m - c); if (dd < bd) { bd = dd; best = i; } });
      ds.forEach(function (d, i) { d.classList.toggle('is-on', i === best); });
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
    mark();
  }

  /* ---------- ir a la compra / a una sección ---------- */
  function buyTarget() { return $('[data-uz-form]') || $('[data-uv-form]') || $('.pd-offers') || $('form[action*="/cart/add"]'); }
  function scrollToEl(el, off) {
    if (!el) return false;
    var t = el.getBoundingClientRect().top + window.pageYOffset - (off || 84);
    window.scrollTo({ top: t, behavior: reduce ? 'auto' : 'smooth' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cv-buy]');
    if (a) { if (scrollToEl(buyTarget())) e.preventDefault(); return; }
    var g = e.target.closest && e.target.closest('[data-cv-goto]');
    if (g) { var sel = g.getAttribute('data-cv-goto'); var tgt = null; try { tgt = $(sel); } catch (err) {} if (scrollToEl(tgt, 70)) e.preventDefault(); }
  });

  /* ---------- barra fija de compra ---------- */
  function initSticky(bar) {
    if (bar.__cv) return; bar.__cv = true;
    document.body.classList.add('cv-sticky-on');
    var form = $('[data-uv-form]'); var anchor = $('[data-uv-atc-main]') || form;
    var offersBox = $('.pd-offers') || form;
    var tEl = $('[data-cv-sticky-title]', bar), pEl = $('[data-cv-sticky-price]', bar), wEl = $('[data-cv-sticky-was]', bar);
    var btn = $('[data-cv-sticky-btn]', bar);
    var name = tEl ? tEl.getAttribute('data-name') : '';
    function sync() {
      var o = form && $('.pd-offer.is-selected', form); if (!o) return;
      var title = o.getAttribute('data-title') || '';
      if (tEl) tEl.textContent = name ? name + ' · ' + title : title;
      if (pEl && o.getAttribute('data-price')) pEl.textContent = o.getAttribute('data-price');
      var was = $('.pd-offer__was', o);
      if (wEl) wEl.textContent = was ? was.textContent : '';
    }
    sync();
    if (form) form.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-uv-offer]')) setTimeout(sync, 0); });
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      var main = form && $('.uv-atc', form);
      if (bar.getAttribute('data-direct') === 'true' && main && !main.disabled) { main.click(); }
      else { scrollToEl(buyTarget()); }
    });
    var passed = false, formVisible = false, last = null;
    function paint() {
      var on = passed && !formVisible;
      if (on === last) return; last = on;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('cv-has-bar', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      $$('a, button', bar).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
    }
    if (!anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) { var e = en[0]; passed = !e.isIntersecting && e.boundingClientRect.top < 0; paint(); }).observe(anchor);
    new IntersectionObserver(function (en) { formVisible = en[0].isIntersecting; paint(); }, { threshold: 0.12 }).observe(offersBox);
  }

  function scan(root) {
    root = root || document;
    reveal(root);
    $$('[data-cv-cd]', root).forEach(initCd);
    $$('[data-cv-rotator]', root).forEach(initRotator);
    $$('[data-cv-pain]', root).forEach(initPain);
    $$('[data-cv-rail]', root).forEach(initRail);
    $$('[data-cv-sticky]', root).forEach(initSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:block:select', function (e) { $$('[data-cv-reveal]', e.target).concat([e.target]).forEach(function (el) { if (el.classList) el.classList.add('is-in'); }); });
})();
